"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var done_icon_dark_svg_1 = __importDefault(require("res/img/done-icon-dark.svg"));
var Checkbox = function (_a) {
    var checked = _a.checked, label = _a.label, onChange = _a.onChange, disabled = _a.disabled;
    return (react_1.default.createElement("div", { className: 'checkbox flex flex-row', "aria-selected": checked, "data-disabled": disabled, "aria-disabled": disabled, onClick: function () { if (!disabled)
            onChange(); } },
        react_1.default.createElement("div", { className: 'checkbox__box' }, checked &&
            react_1.default.createElement("img", { src: done_icon_dark_svg_1.default, alt: 'Checked' })),
        react_1.default.createElement("span", { className: 'checkbox__label' }, label)));
};
exports.default = Checkbox;
